import Label from "../atoms/forms/Label";
import ProfileImage from "../atoms/ProfileImage";

type Props = {
  label?: string;
  profileImage: any;
  defaultImage: JSX.Element;
  alt: string;
};

function ProfileImageElement({ profileImage, label, defaultImage, alt }: Props) {
  return (
    <div className="w-full">
      {label && <Label htmlFor="" label={label} />}
      <div className="mt-1 flex items-center">
        <ProfileImage profileImage={profileImage} defaultImage={defaultImage} alt={alt} />
      </div>
    </div>
  );
}
export default ProfileImageElement;

ProfileImageElement.defaultProps = {
  label: "",
};
